<template>
  <div class="text-center mb-2">
    <img
      :src="data.content"
      style="max-width: 100%"
      alt="обложка"
      title="обложка"
    />
  </div>
</template>

<script>
export default {
  name: "BlockCover",
  props: {
    data: {
      type: Object,
      required: true,
      content: {
        type: String,
        default: ""
      }
    }
  }
};
</script>
